// extracted by mini-css-extract-plugin
export default {"maindiv":"Check_maindiv__kmlqo","subdiv":"Check_subdiv__+b0k1"};